export default __webpack_public_path__ + "static/media/design-illustration-2.2177a971.svg";